<template lang="pug">
  //- @mouseover.prevent.stop="focus"
  //- @mouseleave.prevent.stop="leave"
    //
  a.preview-image(
    href
    :class="{ maximized }"
    @click.prevent.stop
    v-touch:tap="($event) => $emit('maximize', { event: $event, media })"
  )
    Picture(
      v-if="media.image"
      :show-spinner="false"
      :image="media.image"
      :lazy="true"
      :missing-icon="false"
      fit="fit"
      optimize="speed"
      :style="style"
    )
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PreviewImage',
  data: () => ({
    loaded: false
  }),
  props: {
    media: {
      type: Object,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    preferredWidth: {
      type: Number
    },
    aspectRatio: {
      type: Number
    },
    maximized: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    w() {
      let width = this.media.image.width;
      // NOTE: check for retina and other high dpi screens
      if (this.preferredWidth) {
        width = Math.min(this.preferredWidth, width);
      }
      return width;
    },
    h() {
      let height;
      if (this.aspectRatio) height = this.w / this.aspectRatio;
      else height = this.w / (this.media.image.width / this.media.image.height);
      return height;
    },
    style() {
      return {
        width: `${this.w}px`,
        height: `${this.h}px`
      };
    },
    ...mapGetters({
      webpSupport: 'webpSupport'
    })
  }
};
</script>

<style lang="sass" scoped>
a.preview-image
  &:hover,
  &:focus
    @apply shadow-lg
  &.maximized
    @apply shadow-lg
    // display: none
  .picture-container
    @apply shadow rounded-sm overflow-hidden
    overflow: hidden
    background-position: center
    background-repeat: no-repeat
    background-size: cover
    transition: box-shadow .3s ease
</style>
